// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: white !important;
}

.under-img {
  margin-bottom: 80px !important;
}

.header-img {
  width: 125px !important;
  margin-top: 15px !important;
}

.login button {
  background-color: #192352 !important;
}

.header-img {
  width: 73px !important;
}

html, body, app-root, app-login-v4 {
  height: 100%;
  display: block;
}

app-login {
  display: flex;
  flex-direction: column;
  height: 100% !important;
}

body {
  background-color: white !important;
  position: relative;
  margin: 0 !important;
}

.under-img span {
  font-weight: 600;
}

.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-xs-1,
.col-xs-10,
.col-xs-11,
.col-xs-12,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9 {
  padding: 0 !important;
}

.login-container {
  margin: auto !important;
  padding: 30px;
}

.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.wrapper {
  margin: auto;
  width: 484px;
  text-align: center;
  padding: 40px 80px 50px 80px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff !important;
  box-shadow: 0 2px 6px 0 rgba(176, 186, 197, 0.6);
  z-index: 10;
  vertical-align: middle;
  position: relative;
}

.wrapper input {
  width: 100%;
  height: 55px;
  border-radius: 5px;
  border: solid 1px #ccd2d5;
  margin-bottom: 20px;
  background-color: transparent;
  padding-left: 57.5px;
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d;
  outline: none !important;
}

input:focus {
  border-color: #192352;
}

.wrapper input:last-of-type {
  margin-top: 0px;
}

.wrapper img {
  width: 75px;
}

.wrapper input:focus {
  border: solid 1px rgb(24, 115, 177);
}

.control-wrapper {
  text-align: left;
}

.input-password,
.input-username {
  position: relative;
}

.input-password:after,
.input-username:after {
  background: url('icon-password@3x.png');
  content: "";
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 18px;
  top: 16.5px;
}

.input-username:after {
  background-image: url('icon-username@3x.png');
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}

.input-username {
  margin-top: 0px !important;
}

h1,
span {
  font-family: "asapregular";
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  /*letter-spacing: 4px;*/
  text-align: center;
  color: #313541;
}

h1 span {
  font-family: "asapmedium";
}

input[type=checkbox] {
  width: 18px;
  height: 100%;
  margin: 0 !important;
}

.sided {
  height: 30px;
  display: inline-table;
  table-layout: fixed;
  width: 100%;
  text-align: left;
}

.sided * {
  vertical-align: middle;
}

.sided input {
  display: none;
}

.sided label {
  width: 19px;
}

.sided .sided-child {
  margin-bottom: 10px;
}

.sided p {
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #81898c;
  border-color: #ccd2d5;
  margin: 0 !important;
  padding-left: 12px !important;
  width: 100%;
  display: inline;
}

.login button {
  background-color: #192352;
  height: 55px;
  border-radius: 5px;
  width: 100%;
  font-family: "asapregular" !important;
  font-size: 14px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  border: 0 !important;
  color: #ffffff;
  cursor: pointer;
}

label input {
  display: none;
  /* Hide the default checkbox */
}

/* Style the artificial checkbox */
label span {
  height: 19px;
  width: 19px;
  border: 1px solid #ccd2d5;
  display: inline-block;
  position: relative;
  border-radius: 3px;
  cursor: pointer;
}

/* Style its checked state...with a ticked icon */
[type=checkbox]:checked + span:before {
  content: "";
  width: 14px;
  height: 9px;
  position: absolute;
  top: 6px;
  left: 2px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('cb-check.png');
}

.options {
  margin-top: 30px;
  display: table;
  width: 100%;
}

.options a,
.options a:hover,
.options a:visited {
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  cursor: pointer;
  text-decoration: none !important;
  color: #81898c;
  display: table-cell;
}

.options a {
  margin-bottom: 15px;
}

.options a:first-of-type {
  text-align: left;
}

.options a:last-of-type {
  text-align: right;
}

.forgot-username-label {
  margin-bottom: 10px;
}

.inp-container {
  margin-bottom: 0 !important;
}

#clients {
  margin-top: 250px;
  text-align: center;
  margin-bottom: 70px;
}

.newpassword-label {
  margin-bottom: 20px;
}

.col {
  height: 252px;
}

#clients .logo {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: auto;
  height: 252px;
  display: inline-block;
  vertical-align: middle;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d !important;
}

@media screen and (max-width: 1200px) {
  .logo {
    width: 100%;
    margin-bottom: 50px !important;
  }
  #clients {
    margin-top: 150px !important;
  }
}
.unauthorize-message {
  padding: 20px;
  background-color: #d0021b;
  color: white;
  text-align: center;
  font-family: "asapregular" !important;
}

.error-messages {
  /*height:35px;*/
  padding-top: 10px;
}

.error-messages p {
  font-family: "asapregular";
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #e34c4c;
}

h1 {
  line-height: normal !important;
  padding: 0 !important;
}

button:disabled {
  background-color: #bebbbb !important;
}

.btn-loader {
  position: relative;
  margin-top: 60px;
}

.btn-loader img {
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
  height: 30px;
  width: 30px;
}

.alerts .login-close-alert {
  top: 38px !important;
}

h1,
p,
a,
h2 {
  font-family: "asapbold";
  color: #060E37;
}

h1 {
  font-weight: bold;
  font-size: 22px;
}

.subtitle,
.login-foter p {
  margin: 20px 0 25px 0;
  font-size: 22px;
  font-family: "asapregular";
}

.v4-h {
  display: table;
  width: 85%;
  height: 140px;
  min-height: 140px;
  border-bottom: 2px solid #060E37;
}
.v4-h > * {
  display: table-cell;
  vertical-align: middle;
}
.v4-h > img {
  padding-left: 50px;
  height: 100%;
  object-fit: none;
}
.v4-h div {
  text-align: right;
}
.v4-h div * {
  padding-left: 30px;
}
.v4-h div img {
  height: 23px;
  vertical-align: sub;
}
.v4-h a {
  font-weight: bold;
  font-size: 15px;
  text-transform: uppercase;
}

.login-foter {
  display: flex;
  padding-top: 20px;
  flex-flow: nowrap;
  width: 100%;
  padding-bottom: 30px;
  background-color: #f8f8f8;
  padding-top: 30px;
}
.login-foter p, .login-foter h2 {
  padding: 0;
  margin: 10px;
  font-size: 15px;
}
.login-foter > div {
  vertical-align: top;
}
.login-foter > div:first-of-type {
  padding-left: 120px;
  width: 50%;
}

.v4-main {
  display: flex;
  flex: 1;
}

.message {
  height: 25px;
  margin-bottom: 25px;
}
.message p {
  font-weight: normal;
  font-family: "asapregular";
  color: #d0021b;
  font-size: 15px;
}

.reg-container {
  padding: 30px !important;
}

.error-p {
  font-family: "asapregular" !important;
  color: red;
  margin-bottom: 20px;
  margin-top: -10px;
  width: 100%;
  text-align: left;
}

.error-input {
  border-color: red !important;
}

.p-success {
  color: #bed73b !important;
}

.loader-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 165px;
}

.options-centered * {
  text-align: center !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/login/login.component.scss"],"names":[],"mappings":"AAAA;EACI,kCAAA;AACJ;;AAOA;EACI,8BAAA;AAJJ;;AAOA;EACI,uBAAA;EACA,2BAAA;AAJJ;;AAOA;EACI,oCAAA;AAJJ;;AAOA;EACI,sBAAA;AAJJ;;AAOA;EACI,YAAA;EACA,cAAA;AAJJ;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAJJ;;AAOA;EACI,kCAAA;EACA,kBAAA;EACA,oBAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgDI,qBAAA;AAJJ;;AAOA;EACI,uBAAA;EACA,aAAA;AAJJ;;AAOA;EACI,yBAAA;EACA,0BAAA;AAJJ;;AAOA;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gDAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,wBAAA;AAJJ;;AAOA;EACI,qBAxIa;AAoIjB;;AAOA;EACI,eAAA;AAJJ;;AAOA;EACI,WAAA;AAJJ;;AAOA;EACI,mCAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;;EAEI,kBAAA;AAJJ;;AAOA;;EAEI,uCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AAJJ;;AAOA;EACI,6CAAA;AAJJ;;AAOA;EACI,8CAAA;AAJJ;;AAOA;EACI,0BAAA;AAJJ;;AAQA;;EAEI,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AALJ;;AAQA;EACI,yBAAA;AALJ;;AAQA;EACI,WAAA;EACA,YAAA;EACA,oBAAA;AALJ;;AAQA;EACI,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AALJ;;AAQA;EACI,sBAAA;AALJ;;AAQA;EACI,aAAA;AALJ;;AAQA;EACI,WAAA;AALJ;;AAQA;EACI,mBAAA;AALJ;;AAQA;EACI,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;AALJ;;AAQA;EACI,yBA1Pa;EA2Pb,YAAA;EACA,kBAAA;EACA,WAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;AALJ;;AAuBA;EACI,aAAA;EACA,8BAAA;AApBJ;;AAuBA,kCAAA;AACA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AApBJ;;AAuBA,iDAAA;AACA;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,qCAAA;AApBJ;;AAuBA;EACI,gBAAA;EACA,cAAA;EACA,WAAA;AApBJ;;AAuBA;;;EAGI,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,cAAA;EACA,mBAAA;AApBJ;;AAuBA;EACI,mBAAA;AApBJ;;AAuBA;EACI,gBAAA;AApBJ;;AAuBA;EACI,iBAAA;AApBJ;;AAuBA;EACI,mBAAA;AApBJ;;AAuBA;EACI,2BAAA;AApBJ;;AAuBA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;AApBJ;;AAuBA;EACI,mBAAA;AApBJ;;AAuBA;EACI,aAAA;AApBJ;;AAuBA;EACI,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;AApBJ;;AAuBA;EACI,wBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AApBJ;;AAuBA;EACI,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AApBJ;;AAuBA;EACI,WAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AApBJ;;AAuBA;EACI,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AApBJ;;AAuBA;EACI;IACI,WAAA;IACA,8BAAA;EApBN;EAuBE;IACI,4BAAA;EArBN;AACF;AAwBA;EACI,aAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;AAtBJ;;AAyBA;EACI,eAAA;EACA,iBAAA;AAtBJ;;AAyBA;EACI,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AAtBJ;;AAyBA;EACI,8BAAA;EACA,qBAAA;AAtBJ;;AAyBA;EACI,oCAAA;AAtBJ;;AAyBA;EACI,kBAAA;EACA,gBAAA;AAtBJ;;AAyBA;EACI,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAtBJ;;AAyBA;EACI,oBAAA;AAtBJ;;AAyBA;;;;EAII,uBAAA;EACA,cAAA;AAtBJ;;AAyBA;EACI,iBAAA;EACA,eAAA;AAtBJ;;AAyBA;;EAEI,qBAAA;EACA,eAAA;EACA,0BAAA;AAtBJ;;AAyBA;EACI,cAAA;EACA,UAAA;EACA,aAAA;EACA,iBAAA;EACA,gCAAA;AAtBJ;AAwBI;EACI,mBAAA;EACA,sBAAA;AAtBR;AAyBI;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;AAvBR;AA0BI;EACI,iBAAA;AAxBR;AA0BQ;EACI,kBAAA;AAxBZ;AA2BQ;EACI,YAAA;EACA,mBAAA;AAzBZ;AA6BI;EACI,iBAAA;EACA,eAAA;EACA,yBAAA;AA3BR;;AA+BA;EACI,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;AA5BJ;AA8BI;EACI,UAAA;EACA,YAAA;EACA,eAAA;AA5BR;AA+BI;EACI,mBAAA;AA7BR;AAgCI;EACI,mBAAA;EACA,UAAA;AA9BR;;AAkCA;EACI,aAAA;EACA,OAAA;AA/BJ;;AAkCA;EACI,YAAA;EACA,mBAAA;AA/BJ;AAgCI;EACI,mBAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;AA9BR;;AAkCA;EACI,wBAAA;AA/BJ;;AAkCA;EACI,qCAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AA/BJ;;AAkCA;EACI,4BAAA;AA/BJ;;AAkCA;EACI,yBAAA;AA/BJ;;AAkCA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;AA/BJ;;AAkCA;EACI,6BAAA;AA/BJ","sourcesContent":["body{\r\n    background-color: white !important;\r\n}\r\n\r\n\r\n\r\n$highlightColor: #192352;\r\n$loginPageButtonColor: #192352;\r\n\r\n.under-img {\r\n    margin-bottom: 80px !important;\r\n}\r\n\r\n.header-img {\r\n    width: 125px !important;\r\n    margin-top: 15px !important\r\n}\r\n\r\n.login button {\r\n    background-color: $loginPageButtonColor !important;\r\n}\r\n\r\n.header-img{\r\n    width: 73px !important;\r\n}\r\n\r\nhtml,body,app-root,app-login-v4{\r\n    height: 100%;\r\n    display: block;\r\n}\r\n\r\napp-login{\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100% !important;\r\n}\r\n\r\nbody {\r\n    background-color: white !important;\r\n    position: relative;\r\n    margin: 0 !important;\r\n}\r\n\r\n.under-img span {\r\n    font-weight: 600;\r\n} \r\n\r\n.col-lg-1,\r\n.col-lg-10,\r\n.col-lg-11,\r\n.col-lg-12,\r\n.col-lg-2,\r\n.col-lg-3,\r\n.col-lg-4,\r\n.col-lg-5,\r\n.col-lg-6,\r\n.col-lg-7,\r\n.col-lg-8,\r\n.col-lg-9,\r\n.col-md-1,\r\n.col-md-10,\r\n.col-md-11,\r\n.col-md-12,\r\n.col-md-2,\r\n.col-md-3,\r\n.col-md-4,\r\n.col-md-5,\r\n.col-md-6,\r\n.col-md-7,\r\n.col-md-8,\r\n.col-md-9,\r\n.col-sm-1,\r\n.col-sm-10,\r\n.col-sm-11,\r\n.col-sm-12,\r\n.col-sm-2,\r\n.col-sm-3,\r\n.col-sm-4,\r\n.col-sm-5,\r\n.col-sm-6,\r\n.col-sm-7,\r\n.col-sm-8,\r\n.col-sm-9,\r\n.col-xs-1,\r\n.col-xs-10,\r\n.col-xs-11,\r\n.col-xs-12,\r\n.col-xs-2,\r\n.col-xs-3,\r\n.col-xs-4,\r\n.col-xs-5,\r\n.col-xs-6,\r\n.col-xs-7,\r\n.col-xs-8,\r\n.col-xs-9 {\r\n    padding: 0 !important;\r\n}\r\n\r\n.login-container {\r\n    margin: auto !important;\r\n    padding: 30px;\r\n}\r\n\r\n.row {\r\n    margin-left: 0 !important;\r\n    margin-right: 0 !important;\r\n}\r\n\r\n.wrapper {\r\n    margin: auto;\r\n    width: 484px;\r\n    text-align: center;\r\n    padding: 40px 80px 50px 80px;\r\n    box-sizing: border-box;\r\n    border-radius: 5px;\r\n    background-color: #ffffff !important;\r\n    box-shadow: 0 2px 6px 0 rgb(176 186 197 / 60%);\r\n    z-index: 10;\r\n    vertical-align: middle;\r\n    position: relative;\r\n}\r\n\r\n.wrapper input {\r\n    width: 100%;\r\n    height: 55px;\r\n    border-radius: 5px;\r\n    border: solid 1px #ccd2d5;\r\n    margin-bottom: 20px;\r\n    background-color: transparent;\r\n    padding-left: 57.5px;\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #3d464d;\r\n    outline: none !important;\r\n}\r\n\r\ninput:focus {\r\n    border-color: $highlightColor;\r\n}\r\n\r\n.wrapper input:last-of-type {\r\n    margin-top: 0px;\r\n}\r\n\r\n.wrapper img {\r\n    width: 75px;\r\n}\r\n\r\n.wrapper input:focus {\r\n    border: solid 1px rgb(24, 115, 177);\r\n}\r\n\r\n.control-wrapper {\r\n    text-align: left;\r\n}\r\n\r\n.input-password,\r\n.input-username {\r\n    position: relative;\r\n}\r\n\r\n.input-password:after,\r\n.input-username:after {\r\n    background: url(../../../assets/css/images/platform/icon-password@3x.png);\r\n    content: \"\";\r\n    width: 22px;\r\n    height: 23px;\r\n    background-repeat: no-repeat;\r\n    background-size: contain;\r\n    position: absolute;\r\n    left: 18px;\r\n    top: 16.5px;\r\n}\r\n\r\n.input-username:after {\r\n    background-image: url(../../../assets/css/images/platform/icon-username@3x.png);\r\n}\r\n\r\ninput:-webkit-autofill {\r\n    -webkit-box-shadow: 0 0 0px 1000px white inset;\r\n}\r\n\r\n.input-username {\r\n    margin-top: 0px !important;\r\n}\r\n\r\n\r\nh1,\r\nspan {\r\n    font-family: \"asapregular\";\r\n    font-size: 20px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    /*letter-spacing: 4px;*/\r\n    text-align: center;\r\n    color: #313541;\r\n}\r\n\r\nh1 span {\r\n    font-family: \"asapmedium\";\r\n}\r\n\r\ninput[type=\"checkbox\"] {\r\n    width: 18px;\r\n    height: 100%;\r\n    margin: 0 !important;\r\n}\r\n\r\n.sided {\r\n    height: 30px;\r\n    display: inline-table;\r\n    table-layout: fixed;\r\n    width: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.sided * {\r\n    vertical-align: middle;\r\n}\r\n\r\n.sided input {\r\n    display: none;\r\n}\r\n\r\n.sided label {\r\n    width: 19px;\r\n}\r\n\r\n.sided .sided-child {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.sided p {\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #81898c;\r\n    border-color: #ccd2d5;\r\n    margin: 0 !important;\r\n    padding-left: 12px !important;\r\n    width: 100%;\r\n    display: inline;\r\n}\r\n\r\n.login button {\r\n    background-color: $highlightColor;\r\n    height: 55px;\r\n    border-radius: 5px;\r\n    width: 100%;\r\n    font-family: \"asapregular\" !important;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    border: 0 !important;\r\n    color: #ffffff;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\nlabel input {\r\n    display: none;\r\n    /* Hide the default checkbox */\r\n}\r\n\r\n/* Style the artificial checkbox */\r\nlabel span {\r\n    height: 19px;\r\n    width: 19px;\r\n    border: 1px solid #ccd2d5;\r\n    display: inline-block;\r\n    position: relative;\r\n    border-radius: 3px;\r\n    cursor: pointer;\r\n}\r\n\r\n/* Style its checked state...with a ticked icon */\r\n[type=checkbox]:checked+span:before {\r\n    content: \"\";\r\n    width: 14px;\r\n    height: 9px;\r\n    position: absolute;\r\n    top: 6px;\r\n    left: 2px;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: contain;\r\n    background-image: url(../../../assets/css/images/platform/cb-check.png);\r\n}\r\n\r\n.options {\r\n    margin-top: 30px;\r\n    display: table;\r\n    width: 100%;\r\n}\r\n\r\n.options a,\r\n.options a:hover,\r\n.options a:visited {\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    cursor: pointer;\r\n    text-decoration: none !important;\r\n    color: #81898c;\r\n    display: table-cell;\r\n}\r\n\r\n.options a {\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.options a:first-of-type {\r\n    text-align: left;\r\n}\r\n\r\n.options a:last-of-type {\r\n    text-align: right;\r\n}\r\n\r\n.forgot-username-label {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.inp-container {\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n#clients {\r\n    margin-top: 250px;\r\n    text-align: center;\r\n    margin-bottom: 70px;\r\n}\r\n\r\n.newpassword-label {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.col {\r\n    height: 252px;\r\n}\r\n\r\n#clients .logo {\r\n    background-size: contain;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    margin: auto;\r\n    height: 252px;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n\r\n::-webkit-input-placeholder {\r\n    /* Chrome/Opera/Safari */\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #3d464d !important;\r\n}\r\n\r\n::-moz-placeholder {\r\n    /* Firefox 19+ */\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #3d464d !important;\r\n}\r\n\r\n:-ms-input-placeholder {\r\n    /* IE 10+ */\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #3d464d !important;\r\n}\r\n\r\n:-moz-placeholder {\r\n    /* Firefox 18- */\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #3d464d !important;\r\n}\r\n\r\n@media screen and (max-width: 1200px) {\r\n    .logo {\r\n        width: 100%;\r\n        margin-bottom: 50px !important;\r\n    }\r\n\r\n    #clients {\r\n        margin-top: 150px !important;\r\n    }\r\n}\r\n\r\n.unauthorize-message {\r\n    padding: 20px;\r\n    background-color: #d0021b;\r\n    color: white;\r\n    text-align: center;\r\n    font-family: \"asapregular\" !important;\r\n}\r\n\r\n.error-messages {\r\n    /*height:35px;*/\r\n    padding-top: 10px;\r\n}\r\n\r\n.error-messages p {\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #e34c4c;\r\n}\r\n\r\nh1 {\r\n    line-height: normal !important;\r\n    padding: 0 !important;\r\n}\r\n\r\nbutton:disabled {\r\n    background-color: #bebbbb !important;\r\n}\r\n\r\n.btn-loader {\r\n    position: relative;\r\n    margin-top: 60px;\r\n}\r\n\r\n.btn-loader img {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 0;\r\n    bottom: 0;\r\n    margin: auto;\r\n    height: 30px;\r\n    width: 30px;\r\n}\r\n\r\n.alerts .login-close-alert {\r\n    top: 38px !important;\r\n}\r\n\r\nh1,\r\np,\r\na,\r\nh2 {\r\n    font-family: 'asapbold';\r\n    color: #060E37;\r\n}\r\n\r\nh1 {\r\n    font-weight: bold;\r\n    font-size: 22px;\r\n}\r\n\r\n.subtitle,\r\n.login-foter p {\r\n    margin: 20px 0 25px 0;\r\n    font-size: 22px;\r\n    font-family: 'asapregular'\r\n}\r\n\r\n.v4-h {\r\n    display: table;\r\n    width: 85%;\r\n    height: 140px;\r\n    min-height: 140px;\r\n    border-bottom: 2px solid #060E37;\r\n\r\n    >* {\r\n        display: table-cell;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    >img {\r\n        padding-left: 50px;\r\n        height: 100%;\r\n        object-fit: none;\r\n    }\r\n\r\n    div {\r\n        text-align: right;\r\n\r\n        * {\r\n            padding-left: 30px;\r\n        }\r\n\r\n        img {\r\n            height: 23px;\r\n            vertical-align: sub;\r\n        }\r\n    }\r\n\r\n    a {\r\n        font-weight: bold;\r\n        font-size: 15px;\r\n        text-transform: uppercase;\r\n    }\r\n}\r\n\r\n.login-foter {\r\n    display: flex;\r\n    padding-top: 20px;\r\n    flex-flow: nowrap;\r\n    width: 100%;\r\n    padding-bottom: 30px;\r\n    background-color: #f8f8f8;\r\n    padding-top: 30px;\r\n\r\n    p,h2{\r\n        padding: 0;\r\n        margin: 10px;\r\n        font-size: 15px;\r\n    }\r\n\r\n    >div {\r\n        vertical-align: top;\r\n    }\r\n\r\n    >div:first-of-type {\r\n        padding-left: 120px;\r\n        width: 50%;\r\n    }\r\n}\r\n\r\n.v4-main{\r\n    display: flex;\r\n    flex: 1;\r\n}\r\n\r\n.message{\r\n    height: 25px;\r\n    margin-bottom: 25px;\r\n    p{\r\n        font-weight: normal;\r\n        font-family: 'asapregular';\r\n        color: #d0021b;\r\n        font-size: 15px;\r\n    }\r\n}\r\n\r\n.reg-container{\r\n    padding: 30px !important;\r\n}\r\n\r\n.error-p{\r\n    font-family: 'asapregular' !important;\r\n    color: red;\r\n    margin-bottom: 20px;\r\n    margin-top: -10px;\r\n    width: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.error-input{\r\n    border-color: red !important;\r\n}\r\n\r\n.p-success{\r\n    color: #bed73b !important;\r\n}\r\n\r\n.loader-wrapper{\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 165px;\r\n}\r\n\r\n.options-centered *{\r\n    text-align: center !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
